import { createDynamicEnvironment } from "@dtm-frontend/shared/utils";
import type DynamicConfiguation from "../assets/dynamic.config.json";
import { HelpdeskToolkitEnvironment } from "./environment.model";

export const dynamicEnvironment = createDynamicEnvironment<HelpdeskToolkitEnvironment, typeof DynamicConfiguation>(
    fetch("../assets/dynamic.config.json").then((config) => config.json()),
    ({ apiDomain, keycloakConfig }) => {
        const apiUrl = `https://${apiDomain}/api/hdtk`;

        return {
            production: false,
            name: "dev",
            keycloakConfig,
            bearerExcludedUrls: [],
            helpdeskToolkitEndpoints: {
                test: `${apiUrl}/test`,
            },
        };
    }
);
